import React from 'react'
import DatePicker from 'react-datepicker'

import style from './style.module.scss'

function TimeInput(props) {
  const { name, value, onChange } = props

  function handleChange(value) {
    onChange({ name, value })
  }

  return (
    <DatePicker
      selected={value}
      onChange={handleChange}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={15}
      timeCaption="Time"
      dateFormat="h:mm aa"
      className={style.wrapper}
    />
  )
}

export default TimeInput
